export const sectionIdMap = [
  { domId: 'nearby-treasures-section', metaId: 1, legacy: ['nearby treasures', 'trending trips', 'trending'] },
  { domId: 'global-hotspots-section', metaId: 2, legacy: ['global hotspots', 'bucket list'] },
  { domId: 'weekend-collection-section', metaId: 3, legacy: ['weekend collection', 'weekend getaway', 'tropical paradise'] },
  { domId: 'visa-free-wonders-section', metaId: 4, legacy: ['visa-free', 'visa free', 'into the wild'] },
  { domId: 'seasons-finest-section', metaId: 5, legacy: ['season', 'seasonal', 'hidden gems', 'offbeat'] },
];